import component from '../property-button.js';
export default component;
